import { AddressRegistration } from "@/components/booking/create/AddressRegistration";
import { Estimate } from "@/components/booking/create/Estimate";
import { ServiceRegistration } from "@/components/booking/create/ServiceRegistration";
import { VehicleCollection } from "@/components/booking/create/VehicleCollection";
import { VehiclePickUp } from "@/components/booking/create/VehiclePickUp";
import {
  VehicleRegistration,
  type VehicleRegistrationHandle,
} from "@/components/booking/create/VehicleRegistration";
import { CreateRequestLayout } from "@/components/customer/CreateRequestLayout";
import { ThemedText } from "@/components/themed-text";
import { BrandColors } from "@/constants/theme";
import { useAuth } from "@/contexts/auth-context";
import { ALL_SERVICES } from "@/data/service-types";
import { useCreateRequestStore } from "@/stores/use-create-request-store";
import { router, useLocalSearchParams } from "expo-router";
import React, { useEffect, useRef } from "react";
import { StyleSheet, Text, View } from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import {
  SafeAreaView,
  useSafeAreaInsets,
} from "react-native-safe-area-context";

export default function QuoteScreen() {
  const { user, theme } = useAuth();
  const { service } = useLocalSearchParams();
  console.log("ss", service);
  const inset = useSafeAreaInsets();
  const { currentStep, setCurrentStep, setFormData } = useCreateRequestStore();
  const vehicleRegistrationRef = useRef<VehicleRegistrationHandle>(null);
  const handleClickButton = () => {
    vehicleRegistrationRef.current?.submit();
  };

  useEffect(() => {
    if (user) {
      setTimeout(() => router.replace("/(tabs)"), 1000);
    }
    if (service) {
      ALL_SERVICES.map((s) => {
        if (s.value === service) {
          setFormData({ service_type: s.value as any, questions: [] });
          setCurrentStep(1);
        }
      });
    }
  }, [user, service]);

  const handleBack = () => {
    setCurrentStep(currentStep - 1);
  };

  return (
    <SafeAreaView
      style={[styles.container, { backgroundColor: theme.background }]}
    >
      {currentStep === 0 ? (
        <>
          <ScrollView
            contentContainerStyle={styles.scrollContent}
            showsVerticalScrollIndicator={false}
            keyboardShouldPersistTaps="handled"
          >
            <ThemedText
              type="title"
              style={[styles.text, { marginBottom: 10 }]}
            >
              Vehicle help, wherever{" "}
              <Text style={{ color: BrandColors.primary }}>you need it.</Text>
            </ThemedText>
            <ThemedText
              style={[styles.text, { marginBottom: 20, maxWidth: 800 }]}
            >
              From roadside assistance and vehicle recovery to transportation
              and mobile vehicle care, book trusted professionals who come to
              you.
            </ThemedText>
            <ServiceRegistration route={false} />
          </ScrollView>
        </>
      ) : currentStep === 1 ? (
        <CreateRequestLayout
          title="Tell us about the vehicle"
          subtitle=" Enter the registration to speed things up, or add the vehicle
              details manually."
          onNext={handleClickButton}
          step={1}
          totalSteps={5}
          onBack={handleBack}
        >
          <View style={{ gap: 12 }}>
            <VehicleRegistration ref={vehicleRegistrationRef} route={false} />
          </View>
        </CreateRequestLayout>
      ) : currentStep === 2 ? (
        <AddressRegistration route={false} />
      ) : currentStep === 3 ? (
        <VehicleCollection route={false} />
      ) : currentStep === 4 ? (
        <VehiclePickUp route={false} />
      ) : (
        <Estimate route={false} />
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  scrollContent: {
    paddingHorizontal: 16,
    paddingBottom: 40,
    paddingTop: 10,
    marginHorizontal: "auto",
    maxWidth: 1024,
  },
  footer: {
    flex: 1,
  },
  backButton: {
    width: 40,
    height: 40,
    borderRadius: 20,
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 20,
  },
  text: {
    textAlign: "center",
    marginHorizontal: "auto",
  },
});
